// src/components/SchemaMarkup.jsx
import { useEffect } from 'react';

const SchemaMarkup = ({ schemas = [], pageId }) => {
  useEffect(() => {
    const ids = schemas.map((_, i) => `ld-json-${pageId}-${i}`);

    // Remove any existing scripts for this page
    ids.forEach(id => document.getElementById(id)?.remove());

    // Inject fresh scripts
    schemas.forEach((schema, i) => {
      const script = document.createElement('script');
      script.id = ids[i];
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      ids.forEach(id => document.getElementById(id)?.remove());
    };
  }, [pageId]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default SchemaMarkup;